import React from "react";
import ChipRegion from "./Chip/ChipRegion";
import ChipLocation from "./Chip/ChipLocation";
import ChipUser from "./Chip/ChipUser";
import ChipMarketingCampaign from "./Chip/ChipMarketingCampaign";
import ChipProductType from "./Chip/ChipProductType";
import ChipInsuranceType from "./Chip/ChipInsuranceType";
import DialogSearchLocation from "./Dialog/Search/DialogSearchLocation";
import DialogSearchRegion from "./Dialog/Search/DialogSearchRegion";
import DialogSearchUser from "./Dialog/Search/DialogSearchUser";
import DialogSearchMarketingCampaign from "./Dialog/Search/DialogSearchMarketingCampaign";
import DialogSearchProductType from "./Dialog/Search/DialogSearchProductType";
import DialogSearchInsuranceType from "./Dialog/Search/DialogSearchInsuranceType";
import Setting from "../Utility/Setting";
import Location from "../Utility/Crud/Location";
import Region from "../Utility/Crud/Region";
import User from "../Utility/Crud/User";
import MarketingCampaign from "../Utility/Crud/MarketingCampaign";
import ProductType from "../Utility/Crud/ProductType";
import InsuranceType from "../Utility/Crud/InsuranceType";
import Security from "../Utility/Security";
import Term from "../Utility/Crud/Term";
import MainContext from "../Context/MainContext/MainContext";
import MUIStack from "@mui/material/Stack";
import MUIMenu from "@mui/material/Menu";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import MUIIconButton from "@mui/material/IconButton";
import MUITooltip from "@mui/material/Tooltip";
import MUITypography from "@mui/material/Typography";
import MUIFilterAltIcon from "@mui/icons-material/FilterAlt";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUICheckIcon from "@mui/icons-material/Check";

export default class QueuePrefilters extends React.Component {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      prefilterMenuAnchor: null,
      pendingRegionTypeTermId: null,
      regionDialogOpen: false,
      locationDialogOpen: false,
      userDialogOpen: false,
      marketingCampaignDialogOpen: false,
      primaryProductTypeDialogOpen: false,
      primaryInsuranceTypeDialogOpen: false,
      filteredRegions: [],
      filteredRegionsWithType: [],
      filteredLocations: [],
      filteredUsers: [],
      filteredMarketingCampaigns: [],
      filteredProductTypes: [],
      filteredInsuranceTypes: [],
      selectedRegionIds: [],
      selectedLocationIds: [],
      selectedUserIds: [],
      selectedMarketingCampaignIds: [],
      selectedPrimaryProductTypeIds: [],
      selectedPrimaryInsuranceTypeIds: [],
      availableRegionTypeTerms: [],
    };
  }

  /**
   * Loads accessible options and restores only explicitly selected prefilters.
   */
  componentDidMount() {
    let availableRegionTypeTerms;
    if (Security.hasPermission("user.viewAllRegions") === true) {
      availableRegionTypeTerms = Term.sort(
        Term.read(this.context.termsIndexed, [
          { key: "type", value: "region_type" },
        ]),
      );
    } else {
      const availableRegionTypeTermIds = {};
      Object.values(this.context.teamUsersIndexed).some((teamUser) => {
        if (teamUser.userId === this.context.currentUser.id) {
          const team = this.context.teamsIndexed[teamUser.teamId];
          if (team && team.departmentId) {
            const department =
              this.context.departmentsIndexed[team.departmentId];
            if (department.jsonPrefilters?.regionTypeTermId) {
              availableRegionTypeTermIds[
                department.jsonPrefilters.regionTypeTermId
              ] = true;
            }
          }
        }

        return false;
      });
      availableRegionTypeTerms = Term.sort(
        Term.read(this.context.termsIndexed, [
          {
            key: "id",
            value: Object.keys(availableRegionTypeTermIds).map(Number),
          },
        ]),
      );
    }

    const filteredRegions = User.getFilteredRegions(
      this.context.currentUser,
      this.context.userprofileLocationsIndexed,
      this.context.regionsIndexed,
      this.context.locationsIndexed,
    );
    const filteredRegionsWithType = filteredRegions.filter((region) => {
      return (
        region.regionTypeTermId ===
        Setting.get("queue.prefilters.regionTypeTermId")
      );
    });
    const filteredLocations = User.getFilteredLocations(
      this.context.currentUser,
      this.context.userprofileLocationsIndexed,
      this.context.locationsIndexed,
    );
    const filteredUsers = User.getFilteredUsers(
      this.context.currentUser,
      this.context.userprofileLocationsIndexed,
      this.context.locationsIndexed,
      this.context.usersIndexed,
      this.context.salesPcrLinksIndexed,
    );
    const filteredMarketingCampaigns = Object.values(
      this.context.marketingCampaignsIndexed,
    );
    const filteredProductTypes = ProductType.sort(
      Object.values(this.context.productTypesIndexed),
    );
    const filteredInsuranceTypes = InsuranceType.sort(
      Object.values(this.context.insuranceTypesIndexed),
    );

    this.setState({
      loaded: true,
      filteredRegions: filteredRegions,
      filteredRegionsWithType: filteredRegionsWithType,
      filteredLocations: filteredLocations,
      filteredUsers: filteredUsers,
      filteredMarketingCampaigns: filteredMarketingCampaigns,
      filteredProductTypes: filteredProductTypes,
      filteredInsuranceTypes: filteredInsuranceTypes,
      selectedRegionIds: this.getVisibleSelectedIds(
        "queue.prefilters.regionIds",
        filteredRegionsWithType,
        Security.hasPermission("queue.useRegionPrefilter") &&
          Security.hasPermission("user.viewAllRegions") === false,
      ),
      selectedLocationIds: this.getVisibleSelectedIds(
        "queue.prefilters.locationIds",
        filteredLocations,
        Security.hasPermission("queue.useLocationPrefilter") &&
          Security.hasPermission("user.viewAllLocations") === false,
      ),
      selectedUserIds: this.getVisibleSelectedIds(
        "queue.prefilters.userIds",
        filteredUsers,
        Security.hasPermission("queue.useUserPrefilter") &&
          Security.hasPermission("user.viewAllUsers") === false,
      ),
      selectedMarketingCampaignIds: this.getVisibleSelectedIds(
        "queue.prefilters.marketingCampaignIds",
        filteredMarketingCampaigns,
        false,
      ),
      selectedPrimaryProductTypeIds: this.getVisibleSelectedIds(
        "queue.prefilters.primaryProductTypeIds",
        filteredProductTypes,
        false,
      ),
      selectedPrimaryInsuranceTypeIds: this.getVisibleSelectedIds(
        "queue.prefilters.primaryInsuranceTypeIds",
        filteredInsuranceTypes,
        false,
      ),
      availableRegionTypeTerms: availableRegionTypeTerms,
    });
  }

  /**
   * Returns stored IDs that still exist in the accessible options.
   *
   * @param {string} settingKey The setting key.
   * @param {array} rows The accessible rows.
   * @param {boolean} useAccessibleRowsByDefault Whether access restrictions make every row an effective filter.
   * @returns {array} The valid selected IDs.
   */
  getVisibleSelectedIds(settingKey, rows, useAccessibleRowsByDefault) {
    if (Setting.get(settingKey)) {
      const selectedIds = Setting.get(settingKey).filter((id) =>
        rows.some((row) => row.id === id),
      );
      if (selectedIds.length > 0) {
        return selectedIds;
      }
    }

    return useAccessibleRowsByDefault ? rows.map((row) => row.id) : [];
  }

  /**
   * Notifies the parent that an applied prefilter changed.
   */
  notifyPrefilterChange() {
    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  /**
   * Opens the add-prefilter menu from an internal or external button.
   *
   * @param {object} event The button click event.
   */
  openPrefilterMenu(event) {
    this.setState({ prefilterMenuAnchor: event.currentTarget });
  }

  /**
   * Returns the active geography type.
   *
   * @returns {number|null} The active region type term ID.
   */
  getActiveRegionTypeTermId() {
    if (
      (Security.hasPermission("queue.useRegionPrefilter") &&
        (this.state.selectedRegionIds.length > 0 ||
          Security.hasPermission("user.viewAllRegions") === false)) ||
      (Security.hasPermission("queue.useLocationPrefilter") &&
        (this.state.selectedLocationIds.length > 0 ||
          Security.hasPermission("user.viewAllLocations") === false))
    ) {
      return Setting.get("queue.prefilters.regionTypeTermId");
    }
    return null;
  }

  /**
   * Opens the region picker for a geography type.
   *
   * @param {number} regionTypeTermId The region type term ID.
   */
  openRegionDialog(regionTypeTermId) {
    this.setState({
      prefilterMenuAnchor: null,
      pendingRegionTypeTermId: regionTypeTermId,
      filteredRegionsWithType: this.state.filteredRegions.filter((region) => {
        return region.regionTypeTermId === regionTypeTermId;
      }),
      regionDialogOpen: true,
    });
  }

  /**
   * Opens the location picker for a geography type.
   *
   * @param {number} regionTypeTermId The region type term ID.
   */
  openLocationDialog(regionTypeTermId) {
    this.setState({
      prefilterMenuAnchor: null,
      pendingRegionTypeTermId: regionTypeTermId,
      locationDialogOpen: true,
    });
  }

  /**
   * Returns tooltip text for selected IDs.
   *
   * @param {array} ids The selected IDs.
   * @param {object} rowsIndexed The indexed rows.
   * @param {Function} getDisplayName The display-name function.
   * @returns {string} The tooltip text.
   */
  getSelectedDisplayNames(ids, rowsIndexed, getDisplayName) {
    const nameLimit = 25;
    const names = ids
      .slice(0, nameLimit)
      .map((id) => getDisplayName(rowsIndexed[id]))
      .join("\n");
    const moreCount = ids.length - nameLimit;
    return moreCount > 0
      ? `${names}\n+ ${moreCount.toLocaleString()} more`
      : names;
  }

  /**
   * Returns a geography filter label, including its type only when multiple types are available.
   *
   * @param {string} filterName The base filter name.
   * @param {number} regionTypeTermId The geography type term ID.
   * @param {number} availableTypeCount The number of available types for this filter.
   * @returns {string} The geography filter label.
   */
  getGeographyLabel(filterName, regionTypeTermId, availableTypeCount) {
    if (availableTypeCount === 1) {
      return filterName;
    }

    return `${filterName} - ${Term.getDisplayName(this.context.termsIndexed[regionTypeTermId])}`;
  }

  /**
   * Sorts prefilters in the fixed display order.
   *
   * @param {array} prefilters The prefilters to sort.
   * @returns {array} The sorted prefilters.
   */
  sortPrefilters(prefilters) {
    const prefilterOrder = [
      "region",
      "location",
      "user",
      "primary-insurance-type",
      "category",
      "campaign",
    ];

    return prefilters.sort((firstPrefilter, secondPrefilter) => {
      const firstPrefilterType = firstPrefilter.key.replace(/-\d+$/, "");
      const secondPrefilterType = secondPrefilter.key.replace(/-\d+$/, "");
      const orderComparison =
        prefilterOrder.indexOf(firstPrefilterType) -
        prefilterOrder.indexOf(secondPrefilterType);

      return orderComparison !== 0
        ? orderComparison
        : firstPrefilter.name.localeCompare(secondPrefilter.name);
    });
  }

  /**
   * Renders the prefilter builder.
   *
   * @returns {JSX.Element} The prefilter controls.
   */
  render() {
    const activeRegionTypeTermId = this.getActiveRegionTypeTermId();
    const regionIsAccessLimited =
      Security.hasPermission("queue.useRegionPrefilter") &&
      Security.hasPermission("user.viewAllRegions") === false;
    const locationIsAccessLimited =
      Security.hasPermission("queue.useLocationPrefilter") &&
      Security.hasPermission("user.viewAllLocations") === false;
    const userIsAccessLimited =
      Security.hasPermission("queue.useUserPrefilter") &&
      Security.hasPermission("user.viewAllUsers") === false;
    const canAddRegion =
      Security.hasPermission("queue.useRegionPrefilter") &&
      regionIsAccessLimited === false &&
      this.state.selectedRegionIds.length === 0 &&
      this.state.filteredRegions.length > 0;
    const canAddLocation =
      Security.hasPermission("queue.useLocationPrefilter") &&
      locationIsAccessLimited === false &&
      this.state.selectedLocationIds.length === 0 &&
      this.state.filteredLocations.length > 0 &&
      this.state.availableRegionTypeTerms.length > 0;
    const canAddUser =
      Security.hasPermission("queue.useUserPrefilter") &&
      userIsAccessLimited === false &&
      this.state.selectedUserIds.length === 0 &&
      this.state.filteredUsers.length > 0;
    const canAddMarketingCampaign =
      Security.hasPermission("queue.useMarketingCampaignPrefilter") &&
      this.state.selectedMarketingCampaignIds.length === 0 &&
      this.state.filteredMarketingCampaigns.length > 0;
    const canAddPrimaryProductType =
      Security.hasPermission("queue.usePrimaryProductTypePrefilter") &&
      this.state.selectedPrimaryProductTypeIds.length === 0 &&
      this.state.filteredProductTypes.length > 0;
    const canAddPrimaryInsuranceType =
      Security.hasPermission("queue.usePrimaryInsuranceTypePrefilter") &&
      this.state.selectedPrimaryInsuranceTypeIds.length === 0 &&
      this.state.filteredInsuranceTypes.length > 0;
    const canAddPrefilter =
      canAddRegion ||
      canAddLocation ||
      canAddUser ||
      canAddMarketingCampaign ||
      canAddPrimaryProductType ||
      canAddPrimaryInsuranceType;
    const hasActivePrefilters =
      regionIsAccessLimited ||
      locationIsAccessLimited ||
      userIsAccessLimited ||
      (Security.hasPermission("queue.useRegionPrefilter") &&
        this.state.selectedRegionIds.length > 0) ||
      (Security.hasPermission("queue.useLocationPrefilter") &&
        this.state.selectedLocationIds.length > 0) ||
      (Security.hasPermission("queue.useUserPrefilter") &&
        this.state.selectedUserIds.length > 0) ||
      (Security.hasPermission("queue.useMarketingCampaignPrefilter") &&
        this.state.selectedMarketingCampaignIds.length > 0) ||
      (Security.hasPermission("queue.usePrimaryProductTypePrefilter") &&
        this.state.selectedPrimaryProductTypeIds.length > 0) ||
      (Security.hasPermission("queue.usePrimaryInsuranceTypePrefilter") &&
        this.state.selectedPrimaryInsuranceTypeIds.length > 0);

    if (
      this.state.loaded === false ||
      (canAddPrefilter === false && hasActivePrefilters === false)
    ) {
      return null;
    }

    return (
      <MUIStack spacing={1} sx={{ width: "100%" }}>
        {this.props.hideHeader !== true && (
          <MUIStack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <MUITypography variant="subtitle2">Prefilters</MUITypography>
            {this.renderAddButton(canAddPrefilter)}
          </MUIStack>
        )}
        {this.props.hideHeader === true && this.props.direction === "row" && (
          <MUIStack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="flex-end"
            sx={{ width: "100%" }}
          >
            {hasActivePrefilters &&
              this.renderActivePrefilters(activeRegionTypeTermId)}
            {this.renderAddButton(canAddPrefilter)}
          </MUIStack>
        )}
        {this.renderPrefilterMenu(activeRegionTypeTermId)}
        {this.props.hideHeader !== true &&
          hasActivePrefilters &&
          this.renderActivePrefilters(activeRegionTypeTermId)}
        {this.props.hideHeader !== true &&
          hasActivePrefilters === false &&
          this.props.direction === "column" && (
            <MUITypography
              variant="caption"
              color="textSecondary"
              sx={{ paddingY: 1, textAlign: "center" }}
            >
              No active prefilters
            </MUITypography>
          )}
        {this.renderDialogs()}
      </MUIStack>
    );
  }

  /**
   * Renders the add-prefilter button.
   *
   * @param {boolean} canAddPrefilter Whether another prefilter is available.
   * @returns {JSX.Element} The funnel button.
   */
  renderAddButton(canAddPrefilter) {
    return (
      <MUITooltip title={canAddPrefilter ? "Add prefilter" : "Prefilters"}>
        <MUIIconButton
          size={this.props.hideHeader === true ? "medium" : "small"}
          aria-label={canAddPrefilter ? "Add prefilter" : "Prefilters"}
          onClick={this.openPrefilterMenu.bind(this)}
        >
          <MUIFilterAltIcon
            fontSize={this.props.hideHeader === true ? "medium" : "small"}
          />
        </MUIIconButton>
      </MUITooltip>
    );
  }

  /**
   * Renders available and active prefilter types.
   *
   * @param {number|null} activeRegionTypeTermId The active geography type.
   * @returns {JSX.Element} The menu.
   */
  renderPrefilterMenu(activeRegionTypeTermId) {
    const prefilters = [];
    const regionIsActive =
      Security.hasPermission("queue.useRegionPrefilter") &&
      (this.state.selectedRegionIds.length > 0 ||
        Security.hasPermission("user.viewAllRegions") === false);
    const locationIsActive =
      Security.hasPermission("queue.useLocationPrefilter") &&
      (this.state.selectedLocationIds.length > 0 ||
        Security.hasPermission("user.viewAllLocations") === false);
    const userIsActive =
      Security.hasPermission("queue.useUserPrefilter") &&
      (this.state.selectedUserIds.length > 0 ||
        Security.hasPermission("user.viewAllUsers") === false);
    const marketingCampaignIsActive =
      Security.hasPermission("queue.useMarketingCampaignPrefilter") &&
      this.state.selectedMarketingCampaignIds.length > 0;
    const primaryProductTypeIsActive =
      Security.hasPermission("queue.usePrimaryProductTypePrefilter") &&
      this.state.selectedPrimaryProductTypeIds.length > 0;
    const primaryInsuranceTypeIsActive =
      Security.hasPermission("queue.usePrimaryInsuranceTypePrefilter") &&
      this.state.selectedPrimaryInsuranceTypeIds.length > 0;
    const regionTerms = this.state.availableRegionTypeTerms.filter((term) => {
      return (
        this.state.filteredRegions.some(
          (region) => region.regionTypeTermId === term.id,
        ) ||
        (regionIsActive && activeRegionTypeTermId === term.id)
      );
    });
    const locationTerms =
      this.state.filteredLocations.length > 0 || locationIsActive
        ? this.state.availableRegionTypeTerms
        : [];

    if (Security.hasPermission("queue.useRegionPrefilter")) {
      regionTerms.forEach((term) => {
        const isActive = regionIsActive && activeRegionTypeTermId === term.id;
        const isCompatible =
          activeRegionTypeTermId === null || activeRegionTypeTermId === term.id;
        prefilters.push({
          key: `region-${term.id}`,
          name: this.getGeographyLabel("Region", term.id, regionTerms.length),
          icon: Region.getIcon({ fontSize: "small" }),
          isActive: isActive,
          isDisabled: isActive || isCompatible === false,
          onClick: () => this.openRegionDialog(term.id),
        });
      });
    }

    if (Security.hasPermission("queue.useLocationPrefilter")) {
      locationTerms.forEach((term) => {
        const isActive = locationIsActive && activeRegionTypeTermId === term.id;
        const isCompatible =
          activeRegionTypeTermId === null || activeRegionTypeTermId === term.id;
        prefilters.push({
          key: `location-${term.id}`,
          name: this.getGeographyLabel(
            "Location",
            term.id,
            locationTerms.length,
          ),
          icon: Location.getIcon({ fontSize: "small" }),
          isActive: isActive,
          isDisabled: isActive || isCompatible === false,
          onClick: () => this.openLocationDialog(term.id),
        });
      });
    }

    if (
      Security.hasPermission("queue.useUserPrefilter") &&
      (this.state.filteredUsers.length > 0 || userIsActive)
    ) {
      prefilters.push({
        key: "user",
        name: "User",
        icon: User.getIcon({ fontSize: "small" }),
        isActive: userIsActive,
        isDisabled: userIsActive,
        onClick: () =>
          this.setState({ prefilterMenuAnchor: null, userDialogOpen: true }),
      });
    }

    if (
      Security.hasPermission("queue.useMarketingCampaignPrefilter") &&
      (this.state.filteredMarketingCampaigns.length > 0 ||
        marketingCampaignIsActive)
    ) {
      prefilters.push({
        key: "campaign",
        name: "Campaign",
        icon: MarketingCampaign.getIcon({ fontSize: "small" }),
        isActive: marketingCampaignIsActive,
        isDisabled: marketingCampaignIsActive,
        onClick: () =>
          this.setState({
            prefilterMenuAnchor: null,
            marketingCampaignDialogOpen: true,
          }),
      });
    }

    if (
      Security.hasPermission("queue.usePrimaryProductTypePrefilter") &&
      (this.state.filteredProductTypes.length > 0 || primaryProductTypeIsActive)
    ) {
      prefilters.push({
        key: "category",
        name: "Category",
        icon: ProductType.getIcon({ fontSize: "small" }),
        isActive: primaryProductTypeIsActive,
        isDisabled: primaryProductTypeIsActive,
        onClick: () =>
          this.setState({
            prefilterMenuAnchor: null,
            primaryProductTypeDialogOpen: true,
          }),
      });
    }

    if (
      Security.hasPermission("queue.usePrimaryInsuranceTypePrefilter") &&
      (this.state.filteredInsuranceTypes.length > 0 ||
        primaryInsuranceTypeIsActive)
    ) {
      prefilters.push({
        key: "primary-insurance-type",
        name: "Insurance Type",
        icon: InsuranceType.getIcon({ fontSize: "small" }),
        isActive: primaryInsuranceTypeIsActive,
        isDisabled: primaryInsuranceTypeIsActive,
        onClick: () =>
          this.setState({
            prefilterMenuAnchor: null,
            primaryInsuranceTypeDialogOpen: true,
          }),
      });
    }

    this.sortPrefilters(prefilters);

    return (
      <MUIMenu
        anchorEl={this.state.prefilterMenuAnchor}
        open={!!this.state.prefilterMenuAnchor}
        onClose={() => this.setState({ prefilterMenuAnchor: null })}
        anchorOrigin={
          this.props.alignMenuToRight === true
            ? { vertical: "bottom", horizontal: "right" }
            : undefined
        }
        transformOrigin={
          this.props.alignMenuToRight === true
            ? { vertical: "top", horizontal: "right" }
            : undefined
        }
      >
        {prefilters.map((prefilter) => (
          <MUIMenuItem
            key={prefilter.key}
            disabled={prefilter.isDisabled}
            onClick={prefilter.onClick}
          >
            <MUIListItemIcon>
              {prefilter.isActive ? (
                <MUICheckIcon fontSize="small" />
              ) : (
                prefilter.icon
              )}
            </MUIListItemIcon>
            {prefilter.name}
          </MUIMenuItem>
        ))}
      </MUIMenu>
    );
  }

  /**
   * Renders active prefilter chips.
   *
   * @param {number|null} activeRegionTypeTermId The active geography type.
   * @returns {JSX.Element} The chips.
   */
  renderActivePrefilters(activeRegionTypeTermId) {
    const activePrefilters = [];
    const canEditRegion = this.state.filteredRegionsWithType.length > 1;
    const canEditLocation = this.state.filteredLocations.length > 1;
    const canEditUser = this.state.filteredUsers.length > 1;
    const canEditMarketingCampaign =
      this.state.filteredMarketingCampaigns.length > 1;
    const canEditPrimaryProductType =
      this.state.filteredProductTypes.length > 1;
    const canEditPrimaryInsuranceType =
      this.state.filteredInsuranceTypes.length > 1;
    const regionTerms = this.state.availableRegionTypeTerms.filter((term) => {
      return (
        this.state.filteredRegions.some(
          (region) => region.regionTypeTermId === term.id,
        ) || activeRegionTypeTermId === term.id
      );
    });
    const locationTerms = this.state.availableRegionTypeTerms;
    const regionLabel = this.getGeographyLabel(
      "Region",
      activeRegionTypeTermId,
      regionTerms.length,
    );
    const locationLabel = this.getGeographyLabel(
      "Location",
      activeRegionTypeTermId,
      locationTerms.length,
    );

    if (
      Security.hasPermission("queue.useRegionPrefilter") &&
      (this.state.selectedRegionIds.length > 0 ||
        Security.hasPermission("user.viewAllRegions") === false)
    ) {
      activePrefilters.push({
        key: "region",
        name: regionLabel,
        chip: (
          <ChipRegion
            region={
              this.state.selectedRegionIds.length === 1
                ? this.context.regionsIndexed[this.state.selectedRegionIds[0]]
                : null
            }
            hasSelection={true}
            labelPrefix={regionTerms.length > 1 ? regionLabel : undefined}
            nullLabel={`${regionLabel} (${this.state.selectedRegionIds.length})`}
            tooltip={this.getSelectedDisplayNames(
              this.state.selectedRegionIds,
              this.context.regionsIndexed,
              Region.getDisplayName,
            )}
            onClick={
              canEditRegion
                ? () => this.openRegionDialog(activeRegionTypeTermId)
                : undefined
            }
            onDelete={
              canEditRegion
                ? () => this.openRegionDialog(activeRegionTypeTermId)
                : undefined
            }
            deleteIcon={canEditRegion ? <MUIEditIcon /> : undefined}
          />
        ),
      });
    }

    if (
      Security.hasPermission("queue.useLocationPrefilter") &&
      (this.state.selectedLocationIds.length > 0 ||
        Security.hasPermission("user.viewAllLocations") === false)
    ) {
      activePrefilters.push({
        key: "location",
        name: locationLabel,
        chip: (
          <ChipLocation
            location={
              this.state.selectedLocationIds.length === 1
                ? this.context.locationsIndexed[
                    this.state.selectedLocationIds[0]
                  ]
                : null
            }
            hasSelection={true}
            labelPrefix={locationTerms.length > 1 ? locationLabel : undefined}
            nullLabel={`${locationLabel} (${this.state.selectedLocationIds.length})`}
            tooltip={this.getSelectedDisplayNames(
              this.state.selectedLocationIds,
              this.context.locationsIndexed,
              Location.getDisplayName,
            )}
            onClick={
              canEditLocation
                ? () => this.openLocationDialog(activeRegionTypeTermId)
                : undefined
            }
            onDelete={
              canEditLocation
                ? () => this.openLocationDialog(activeRegionTypeTermId)
                : undefined
            }
            deleteIcon={canEditLocation ? <MUIEditIcon /> : undefined}
          />
        ),
      });
    }

    if (
      Security.hasPermission("queue.useUserPrefilter") &&
      (this.state.selectedUserIds.length > 0 ||
        Security.hasPermission("user.viewAllUsers") === false)
    ) {
      activePrefilters.push({
        key: "user",
        name: "User",
        chip: (
          <ChipUser
            user={
              this.state.selectedUserIds.length === 1
                ? this.context.usersIndexed[this.state.selectedUserIds[0]]
                : null
            }
            hasSelection={true}
            nullLabel={`User (${this.state.selectedUserIds.length})`}
            tooltip={this.getSelectedDisplayNames(
              this.state.selectedUserIds,
              this.context.usersIndexed,
              User.getDisplayName,
            )}
            onClick={
              canEditUser
                ? () => this.setState({ userDialogOpen: true })
                : undefined
            }
            onDelete={
              canEditUser
                ? () => this.setState({ userDialogOpen: true })
                : undefined
            }
            deleteIcon={canEditUser ? <MUIEditIcon /> : undefined}
          />
        ),
      });
    }

    if (
      Security.hasPermission("queue.useMarketingCampaignPrefilter") &&
      this.state.selectedMarketingCampaignIds.length > 0
    ) {
      activePrefilters.push({
        key: "campaign",
        name: "Campaign",
        chip: (
          <ChipMarketingCampaign
            marketingCampaign={
              this.state.selectedMarketingCampaignIds.length === 1
                ? this.context.marketingCampaignsIndexed[
                    this.state.selectedMarketingCampaignIds[0]
                  ]
                : null
            }
            hasSelection={true}
            nullLabel={`Campaign (${this.state.selectedMarketingCampaignIds.length})`}
            tooltip={this.getSelectedDisplayNames(
              this.state.selectedMarketingCampaignIds,
              this.context.marketingCampaignsIndexed,
              MarketingCampaign.getDisplayName,
            )}
            onClick={
              canEditMarketingCampaign
                ? () => this.setState({ marketingCampaignDialogOpen: true })
                : undefined
            }
            onDelete={
              canEditMarketingCampaign
                ? () => this.setState({ marketingCampaignDialogOpen: true })
                : undefined
            }
            deleteIcon={canEditMarketingCampaign ? <MUIEditIcon /> : undefined}
          />
        ),
      });
    }

    if (
      Security.hasPermission("queue.usePrimaryProductTypePrefilter") &&
      this.state.selectedPrimaryProductTypeIds.length > 0
    ) {
      activePrefilters.push({
        key: "category",
        name: "Category",
        chip: (
          <ChipProductType
            productType={
              this.state.selectedPrimaryProductTypeIds.length === 1
                ? this.context.productTypesIndexed[
                    this.state.selectedPrimaryProductTypeIds[0]
                  ]
                : null
            }
            hasSelection={true}
            nullLabel={`Category (${this.state.selectedPrimaryProductTypeIds.length})`}
            tooltip={this.getSelectedDisplayNames(
              this.state.selectedPrimaryProductTypeIds,
              this.context.productTypesIndexed,
              ProductType.getDisplayName,
            )}
            onClick={
              canEditPrimaryProductType
                ? () => this.setState({ primaryProductTypeDialogOpen: true })
                : undefined
            }
            onDelete={
              canEditPrimaryProductType
                ? () => this.setState({ primaryProductTypeDialogOpen: true })
                : undefined
            }
            deleteIcon={canEditPrimaryProductType ? <MUIEditIcon /> : undefined}
          />
        ),
      });
    }

    if (
      Security.hasPermission("queue.usePrimaryInsuranceTypePrefilter") &&
      this.state.selectedPrimaryInsuranceTypeIds.length > 0
    ) {
      activePrefilters.push({
        key: "primary-insurance-type",
        name: "Insurance Type",
        chip: (
          <ChipInsuranceType
            insuranceType={
              this.state.selectedPrimaryInsuranceTypeIds.length === 1
                ? this.context.insuranceTypesIndexed[
                    this.state.selectedPrimaryInsuranceTypeIds[0]
                  ]
                : null
            }
            hasSelection={true}
            nullLabel={`Insurance Type (${this.state.selectedPrimaryInsuranceTypeIds.length})`}
            tooltip={this.getSelectedDisplayNames(
              this.state.selectedPrimaryInsuranceTypeIds,
              this.context.insuranceTypesIndexed,
              InsuranceType.getDisplayName,
            )}
            onClick={
              canEditPrimaryInsuranceType
                ? () => this.setState({ primaryInsuranceTypeDialogOpen: true })
                : undefined
            }
            onDelete={
              canEditPrimaryInsuranceType
                ? () => this.setState({ primaryInsuranceTypeDialogOpen: true })
                : undefined
            }
            deleteIcon={
              canEditPrimaryInsuranceType ? <MUIEditIcon /> : undefined
            }
          />
        ),
      });
    }

    this.sortPrefilters(activePrefilters);

    return (
      <MUIStack
        direction={this.props.direction}
        spacing={this.props.direction === "column" ? 1 : 0}
        sx={{
          alignItems: "flex-start",
          ...(this.props.direction === "row"
            ? {
                flexWrap: "wrap",
                flexGrow: 1,
                gap: 1,
                justifyContent: "flex-end",
                minWidth: 0,
              }
            : {}),
        }}
      >
        {activePrefilters.map((prefilter) =>
          React.cloneElement(prefilter.chip, { key: prefilter.key }),
        )}
      </MUIStack>
    );
  }

  /**
   * Renders prefilter selection dialogs.
   *
   * @returns {JSX.Element} The dialogs.
   */
  renderDialogs() {
    const regionIsAccessLimited =
      Security.hasPermission("user.viewAllRegions") === false;
    const locationIsAccessLimited =
      Security.hasPermission("user.viewAllLocations") === false;
    const userIsAccessLimited =
      Security.hasPermission("user.viewAllUsers") === false;

    return (
      <>
        {Security.hasPermission("queue.useRegionPrefilter") && (
          <DialogSearchRegion
            data={this.state.filteredRegionsWithType}
            open={this.state.regionDialogOpen}
            onClose={() => this.setState({ regionDialogOpen: false })}
            onSelect={(region) => {
              this.setState({ selectedRegionIds: [region.id] });
              Setting.set(
                "queue.prefilters.regionTypeTermId",
                this.state.pendingRegionTypeTermId,
              );
              Setting.set("queue.prefilters.regionIds", [region.id]);
              this.notifyPrefilterChange();
            }}
            onClear={
              this.state.selectedRegionIds.length > 0 &&
              (regionIsAccessLimited === false ||
                Setting.get("queue.prefilters.regionIds") !== undefined)
                ? () => {
                    this.setState({
                      selectedRegionIds: regionIsAccessLimited
                        ? this.state.filteredRegionsWithType.map(
                            (region) => region.id,
                          )
                        : [],
                      regionDialogOpen: false,
                    });
                    Setting.clear("queue.prefilters.regionIds");
                    this.notifyPrefilterChange();
                  }
                : undefined
            }
            clearLabel={
              regionIsAccessLimited ? "Reset Filter" : "Remove Filter"
            }
          />
        )}
        {Security.hasPermission("queue.useLocationPrefilter") && (
          <DialogSearchLocation
            data={this.state.filteredLocations}
            open={this.state.locationDialogOpen}
            onClose={() => this.setState({ locationDialogOpen: false })}
            onSelect={(locations) => {
              const locationIds = locations.map((location) => location.id);
              this.setState({ selectedLocationIds: locationIds });
              Setting.set(
                "queue.prefilters.regionTypeTermId",
                this.state.pendingRegionTypeTermId,
              );
              Setting.set("queue.prefilters.locationIds", locationIds);
              this.notifyPrefilterChange();
            }}
            onClear={
              this.state.selectedLocationIds.length > 0 &&
              (locationIsAccessLimited === false ||
                Setting.get("queue.prefilters.locationIds") !== undefined)
                ? () => {
                    this.setState({
                      selectedLocationIds: locationIsAccessLimited
                        ? this.state.filteredLocations.map(
                            (location) => location.id,
                          )
                        : [],
                      locationDialogOpen: false,
                    });
                    Setting.clear("queue.prefilters.locationIds");
                    this.notifyPrefilterChange();
                  }
                : undefined
            }
            clearLabel={
              locationIsAccessLimited ? "Reset Filter" : "Remove Filter"
            }
            multiSelect={true}
            requireSelection={true}
            selected={Location.read(this.context.locationsIndexed, [
              { key: "id", value: this.state.selectedLocationIds },
            ])}
          />
        )}
        {Security.hasPermission("queue.useUserPrefilter") && (
          <DialogSearchUser
            data={this.state.filteredUsers}
            open={this.state.userDialogOpen}
            onClose={() => this.setState({ userDialogOpen: false })}
            onSelect={(user) => {
              this.setState({ selectedUserIds: [user.id] });
              Setting.set("queue.prefilters.userIds", [user.id]);
              this.notifyPrefilterChange();
            }}
            onClear={
              this.state.selectedUserIds.length > 0 &&
              (userIsAccessLimited === false ||
                Setting.get("queue.prefilters.userIds") !== undefined)
                ? () => {
                    this.setState({
                      selectedUserIds: userIsAccessLimited
                        ? this.state.filteredUsers.map((user) => user.id)
                        : [],
                      userDialogOpen: false,
                    });
                    Setting.clear("queue.prefilters.userIds");
                    this.notifyPrefilterChange();
                  }
                : undefined
            }
            clearLabel={userIsAccessLimited ? "Reset Filter" : "Remove Filter"}
          />
        )}
        {Security.hasPermission("queue.useMarketingCampaignPrefilter") && (
          <DialogSearchMarketingCampaign
            data={this.state.filteredMarketingCampaigns}
            open={this.state.marketingCampaignDialogOpen}
            onClose={() =>
              this.setState({ marketingCampaignDialogOpen: false })
            }
            onSelect={(marketingCampaigns) => {
              const marketingCampaignIds = marketingCampaigns.map(
                (marketingCampaign) => marketingCampaign.id,
              );
              this.setState({
                selectedMarketingCampaignIds: marketingCampaignIds,
              });
              Setting.set(
                "queue.prefilters.marketingCampaignIds",
                marketingCampaignIds,
              );
              this.notifyPrefilterChange();
            }}
            onClear={
              this.state.selectedMarketingCampaignIds.length > 0
                ? () => {
                    this.setState({
                      selectedMarketingCampaignIds: [],
                      marketingCampaignDialogOpen: false,
                    });
                    Setting.clear("queue.prefilters.marketingCampaignIds");
                    this.notifyPrefilterChange();
                  }
                : undefined
            }
            multiSelect={true}
            requireSelection={true}
            selected={MarketingCampaign.read(
              this.context.marketingCampaignsIndexed,
              [{ key: "id", value: this.state.selectedMarketingCampaignIds }],
            )}
          />
        )}
        {Security.hasPermission("queue.usePrimaryProductTypePrefilter") && (
          <DialogSearchProductType
            data={this.state.filteredProductTypes}
            open={this.state.primaryProductTypeDialogOpen}
            onClose={() =>
              this.setState({ primaryProductTypeDialogOpen: false })
            }
            onSelect={(productTypes) => {
              const productTypeIds = productTypes.map(
                (productType) => productType.id,
              );
              this.setState({ selectedPrimaryProductTypeIds: productTypeIds });
              Setting.set(
                "queue.prefilters.primaryProductTypeIds",
                productTypeIds,
              );
              this.notifyPrefilterChange();
            }}
            onClear={
              this.state.selectedPrimaryProductTypeIds.length > 0
                ? () => {
                    this.setState({
                      selectedPrimaryProductTypeIds: [],
                      primaryProductTypeDialogOpen: false,
                    });
                    Setting.clear("queue.prefilters.primaryProductTypeIds");
                    this.notifyPrefilterChange();
                  }
                : undefined
            }
            multiSelect={true}
            requireSelection={true}
            selected={ProductType.read(this.context.productTypesIndexed, [
              { key: "id", value: this.state.selectedPrimaryProductTypeIds },
            ])}
          />
        )}
        {Security.hasPermission("queue.usePrimaryInsuranceTypePrefilter") && (
          <DialogSearchInsuranceType
            data={this.state.filteredInsuranceTypes}
            open={this.state.primaryInsuranceTypeDialogOpen}
            onClose={() =>
              this.setState({ primaryInsuranceTypeDialogOpen: false })
            }
            onSelect={(insuranceTypes) => {
              const insuranceTypeIds = insuranceTypes.map(
                (insuranceType) => insuranceType.id,
              );
              this.setState({
                selectedPrimaryInsuranceTypeIds: insuranceTypeIds,
              });
              Setting.set(
                "queue.prefilters.primaryInsuranceTypeIds",
                insuranceTypeIds,
              );
              this.notifyPrefilterChange();
            }}
            onClear={
              this.state.selectedPrimaryInsuranceTypeIds.length > 0
                ? () => {
                    this.setState({
                      selectedPrimaryInsuranceTypeIds: [],
                      primaryInsuranceTypeDialogOpen: false,
                    });
                    Setting.clear("queue.prefilters.primaryInsuranceTypeIds");
                    this.notifyPrefilterChange();
                  }
                : undefined
            }
            multiSelect={true}
            requireSelection={true}
            selected={InsuranceType.read(this.context.insuranceTypesIndexed, [
              { key: "id", value: this.state.selectedPrimaryInsuranceTypeIds },
            ])}
          />
        )}
      </>
    );
  }
}
